import React, { Component, Fragment } from 'react';
import { LangEum, preFix } from '@/constant'
import styles from './index.module.less'
import { handleStyle, px2rem } from '@/utils/styleUtils'
import { removeObjEmptyKey } from '@/utils/objUtils';
import classnames from 'classnames';
import { EditConfigType } from '@/typings/types'
import imgResize from '@/utils/img-resize'
import GuideBrowserManager from '@/common/guideBrowser';

class Index extends Component<{
  editConfig: EditConfigType
  propsConfig: any
}> {
  static config = {
    name: 'poizon-img',
  }
  componentDidMount() {}
  getRuleText = () => {
    const { lang } = this.props.editConfig;
    const { propsConfig } = this.props;
    const zhTW = '活動規則'
    const map = {
      zh: '活动规则',
      [LangEum['zh-TW']]: zhTW,
      [LangEum['zh-MO']]: zhTW,
      [LangEum['zh-TW2']]: zhTW,
      [LangEum['zh-SG']]: '活动规则',
      [LangEum['zh-MY']]: '活动规则',
      en: 'Rules',
      ja: 'ルール',
      ko: '행사규칙',
    };
    if (propsConfig && propsConfig.font && propsConfig.font.fontWord) {
      return propsConfig.font.fontWord
    }
    return map[lang] || 'Rules';
  };
  handleToRule = () => {};

  getFontWordStyle = () => {
    const { propsConfig } = this.props;
    if (propsConfig === null) return {};
    const font = propsConfig.font || {};
    const style = removeObjEmptyKey({
      fontSize: font.fontSize,
      fontWeight: font.fontWeight,
      color: font.fontColor || 'rgba(255, 255, 255, 0.7)',
      top: font.fontTop ? px2rem(font.fontTop) : '0.06rem',
      right: font.fontRight ? px2rem(font.fontRight) : '0.22rem',
    });
    return style;
  };

  render() {
    const { propsConfig } = this.props;
    if (!propsConfig) return ''
    const { url = '', style, ruleUrl = '' } = propsConfig
    return (
      <div className={(preFix + Index.name, styles.normal)} style={handleStyle(style)}>
        {ruleUrl.trim() && (
          <Fragment>
            <a
              className={classnames({
                [styles.rule]: true,
              })}
              href={ruleUrl}
              style={this.getFontWordStyle()}
              // target="_blank"
              // rel="noopener noreferrer"
            >
              {this.getRuleText()}
            </a>
          </Fragment>
        )}
        <img alt="cover" className={styles.img} src={imgResize(url, 750)} />
      </div>
    );
  }
}

export default Index;
